import { useState,useEffect } from "react";
import { useDispatch,useSelector} from "react-redux";
import reload from "../../assets/icons/reload.svg";
import CustomTabsV2 from "../universal/CustomTabsV2";
import CollapsibleRightPanel from "../universal/CollapsibleRightPanel";
import {AddChurchHooks}  from "../../screens/Resources/hooks/resourcehooks";
import { AllChurchHooks } from "../../screens/Resources/hooks/resourcehooks";
import LayoutDropdown from "../universal/LayoutDropdown";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import edit from "../../assets/icons/edit.svg";
import close from "../../assets/icons/close.svg";
import LanguageDrawer from "../universal/LanguageDrawer";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import UploadControlsV2 from "../TWG/UploadControlsV2";

import { toast } from "react-toastify";
import ReactQuill from "react-quill";
import ReactModal from "react-modal";
import { ImCross } from "react-icons/im";
const AddVideosFields = ({ setLoading, data,rowData,onClose,church }) => {
  // const { options } = GetRelatedVideosHooks();
    const churches = useSelector((state) => state.churches.churches);

  const dispatch = useDispatch();

   const {
    activeTab,
    activeLanguageDetails,
    setActiveLanguageDetails,
    setActiveTab,
    handleInputChange,
    handleFileInputChange,
    handleSave,
    readLanguageData,
    videoInputs,

    videoErrors,
    videoUrlsInputs,
    showVideoLibraryModal,
    setShowVideoLibraryModal,
    setVideoUrlsInputs,
    setDownloadUrlsInputs,
    setTumbNailUrlsInputs,
    tumbNailUrlsInputs,
    UdownloadrlsInputs,
    handleChange,
    selectedOptions,
    setSelectedOptions,
    deleteRelatedVideo,
    setSelectedRelatedVideoIndex,
    handleDropdownChange,
    setLayoutValues,
    handleVideoLayoutChange,
    layoutValues,
    initialLayoutValues,
    setLayoutInfo,
    layoutInfo,
    handleDateChange,
    handleAddLayoutToArray,
    layoutArray,
    setAddedLayout,
    addedLayout,
    handleVideoDateChange,
    options,
    handleDeleteLayoutFromArray,
    setIsLayoutEdit,
    isLayoutEdit,
    setEditLayoutIndex,
    setEditTargetLayout,
    editTargetLayout,
    handleLayoutUpdate,
    updateStateWithTranslation,
    handleCommonTumbNailInputChange,
    setCommonUrlsInputs,
    commonVideoUrlsInputs,
    previewUrlsInputs,
    setPreviewUrlsInputs,
    languagemeta,
    setIsLanguageSave,
    handleSaveLanguage,
    handleLibraryVideoSelection,
    handleSendNotification,
    handleUpdateChurch,
    setImageSet,
    setChurchInputs,
    churchInputs,
    thumbnailImage, setThumbnailImage,
    isLive,setIslive,
    isDefault,setIsDefault
  } = AddChurchHooks(setLoading, data);


  const [showModal, setShowModal] = useState(false);
  const [isImage, setIsImage] = useState(false);
  const [currentUrl, setCurrentUrl] = useState("");
  const [selectedLocation, setSelectedLocation] = useState({
    lat: "",
    lng: "",
    address: ""
  });
        const { userInfo } = useSelector((state) => state.user);



const handleGallerySelect = (imageSet) => {
  setImageSet(imageSet)
      setTumbNailUrlsInputs({
      webUploadUrl: imageSet?.target?.value?.web?.url || "",
      tabletUploadUrl: imageSet?.target?.value?.tablet?.url || "",
      mobileUploadUrl: imageSet?.target?.value?.mobile?.url || "",
    });

  };
  const [resourceDescription, setResourceDescription] = useState(rowData?.resourceDescription || "");

// useEffect(() => {
//   if (rowData) {
//     setChurchInputs({
//       _id: rowData._id || "",
//       church_id: rowData.church_id || "",
//       resourceName: rowData.resourceName || "",
//       resourceDescription: rowData.resourceDescription || "",
//       categoryName: rowData.categoryName || "",
//       resourceUrl: rowData.resourceUrl || "",
//     });
//   }
// }, [rowData]);
const handleThumbSelect = (img) => {
  setThumbnailImage(img?.target?.value?.[0]?.id);
};
const isQuillEmpty = (value) => {
  const div = document.createElement("div");
  div.innerHTML = value || "";
  return !div.textContent?.trim();
};
const validateResourceFields = () => {
  if (!churchInputs?.resourceName?.trim()) {
    toast.error("Resource Name is required");
    return false;
  }

  if (
    !churchInputs?.resourceDescription ||
    isQuillEmpty(churchInputs.resourceDescription)
  ) {
    toast.error("Resource Description is required");
    return false;
  }

  if (!churchInputs?.categoryName?.trim()) {
    toast.error("Category Name is required");
    return false;
  }

  if (!churchInputs?.resourceUrl?.trim()) {
    toast.error("Resource URL is required");
    return false;
  }

  return true;
};
const [apiResource, setApiResource] = useState(null);
const { fetchAllChurches } = AllChurchHooks();

useEffect(() => {
  if (!rowData?.resourceObjId || !church?._id) return;

  fetchAllChurches(
    1,
    100,
    {},
    (res) => {
      if (!res?.data?.length) return;

      // 🔥 resourceObjId match
      const resource = res.data.find(
        (r) => r.resourceObjId === rowData.resourceObjId
      );

      if (resource) {
        setApiResource(resource);
      }
    },
    church._id
  );
}, [rowData?.resourceObjId, church?._id]);
useEffect(() => {
  if (!apiResource) return;

  setChurchInputs({
    _id: apiResource.resourceObjId,
    church_id: apiResource.churchId,
    resourceName: apiResource.resourceName || "",
    resourceDescription: apiResource.resourceDescription || "", // ✅ HTML SAFE
    categoryName: apiResource.categoryName || "",
    resourceUrl: apiResource.resourceUrl || "",
  });

  setResourceDescription(apiResource.resourceDescription || "");
}, [apiResource]);
const cleanHtmlContent = (htmlContent) => {
  if (!htmlContent) return htmlContent;

  // Remove ALL color-related styles and formatting
  return htmlContent
    // Remove background-color styles
    .replace(/style="[^"]*background-color[^;"]*;?[^"]*"/gi, '')
    // Remove color styles
    .replace(/style="[^"]*color:[^;"]*;?[^"]*"/gi, '')
    // Remove any style attribute that contains color (more comprehensive)
    .replace(/style="[^"]*(color|background|background-color)[^"]*"/gi, '')
    // Remove any style attributes with single quotes
    .replace(/style='[^']*'/gi, '')
    // Remove empty style attributes
    .replace(/style=""/gi, '')
    // Remove any span tags that might have had styling (keeps span but removes all styles)
    .replace(/<span[^>]*>/gi, '<span>')
    // Remove any font tags that might bring color
    .replace(/<font[^>]*>/gi, '')
    .replace(/<\/font>/gi, '')
    // Also remove any color-related CSS classes
    .replace(/class="[^"]*color[^"]*"/gi, '');
};
  return (
    <div className="flex flex-col md:flex-row h-full w-full flex-1 rounded-2xl overflow-hidden">
      <div className="flex h-full flex-1">
        <LanguageDrawer
          languageData={readLanguageData}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          setActiveLanguageDetails={setActiveLanguageDetails}
          languagemeta={languagemeta}
          setIsLanguageSave={setIsLanguageSave}
        />
        <div className="flex h-full flex-1">
          <div className="flex flex-col h-full w-full bg-greyishV2 bg-opacity-50 md:border-l md:border-r border-greyish border-opacity-30 overflow-auto">
            <div className="flex gap-4 items-center justify-between h-[64px] px-4 border-b border-[#28292a]">
              <p className="text-white font-semibold text-lg">
                {activeTab === "en"
                  ? "Add Resource"
                  : `Translate Churche to ${activeLanguageDetails?.language_name}`}
              </p>
              <div className="flex items-center gap-5">
                {activeTab !== "en" && data?._id && (
                  <p
                    className="flex items-center gap-1 text-greyish text-[11px] font-medium cursor-pointer whitespace-nowrap"
                    onClick={updateStateWithTranslation}
                  >
                    <img src={reload} alt="" /> Auto fill data with google translation
                  </p>
                )}
                {data?._id && (
                  <button
                    className="text-yellowish bg-blackish font-medium text-[12px] whitespace-nowrap border border-yellowish rounded-xl py-2 px-6"
                    onClick={handleSendNotification}
                  >
                    Send Notification
                  </button>
                )}
                {activeTab === "en" ? (
                  <div className="w-full flex items-end justify-end gap-4">
                    {/* <button
                      className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                      onClick={handleSave}
                    >
                      {rowData?._id ? "Update Church" : "Save Church"}
                    </button> */}
                    {
                      rowData?.resourceObjId ?
                      <button
                      className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                      onClick={async () => {
                        try {
                          await handleUpdateChurch(rowData,church._id); // ✅ wait for update
                          onClose();                         // ✅ close modal only if success
                        } catch (err) {
                                                    // optionally keep modal open
                        }
                      }}
                    >Update Resource</button>
                    :
                    <button
                    className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                    // onClick={handleSave}
                    onClick={async () => {
                      if (!validateResourceFields()) return;

                      try {
                        await handleSave(userInfo?._id, church._id);
                        onClose();
                      } catch (err) {
                                              }
                    }}

                  >Save Resouce</button>
                    }
                  </div>
                ) : data?._id ? (
                  <div className="w-full flex items-end justify-end gap-4">
                    <button
                      className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                      onClick={handleSaveLanguage}
                    >
                      Save Language
                    </button>
                  </div>
                ) : null}
              </div>
            </div>
            {/* TAB CONTENT  */}
            {activeTab !== "en" && !data?._id ? (
              <div className="flex items-center justify-center text-white gap-1 py-28">
                Church translation in{" "}
                <span className="italic">{activeLanguageDetails?.language_name}</span> is available
                for saved churches
              </div>
            ) : (
                <div className="px-4 my-4 h-full">
                <div className="overflow-y-auto overflow-x-hidden px-2">
                  <div className="grid md:grid-cols-2 grid-cols-1 gap-x-4 gap-y-4 mx-1 w-full">

                    {/* Church Dropdown */}


  <div className="md:col-span-2 col-span-1 relative">
  <label className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2">
    Church *
  </label>

  <input
    type="text"
    name="church_id"
    placeholder="Enter Church Name"
    className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
    value={church ? church.churchName : ""}

    readOnly
  />

  {videoErrors?.church_id && (
    <p className="text-red-500 relative bottom-[-6px] text-[10px] left-2">
      Church selection is required
    </p>
  )}
</div>





                    {/* Resource Name */}
                    <div className="md:col-span-2 col-span-1">
                      <label className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2">
                        Resource Name *
                      </label>
                      <input
                        name="resourceName"
                        placeholder="Enter Resource Name"
                        type="text"
                        className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
                        value={churchInputs?.resourceName || rowData?.resourceName || ""}
                        onChange={handleChange}
                      />
                      {videoErrors?.resourceName && (
                        <p className="text-red-500 relative bottom-[-6px] text-[10px] left-2">
                          Resource Name is required
                        </p>
                      )}
                    </div>

       {/* Resource Description */}
<div className="md:col-span-2 col-span-1">
  <label className="text-[12px] text-greyish font-medium leading-4">
    Resource Description *
  </label>

  <div className="mt-2">
    <ReactQuill
      theme="snow"
      value={resourceDescription || rowData?.resourceDescription || ""}
      onChange={(value) => {
        const cleanedValue = cleanHtmlContent(value); // Clean the HTML content
        setResourceDescription(cleanedValue);
        handleChange({ target: { name: "resourceDescription", value: cleanedValue } }); // propagate change
      }}
      placeholder="Enter Resource Description"
      className="text-white text-[14px] font-medium rounded-md bg-blackish quill-custom"
    />
  </div>

  {videoErrors?.resourceDescription && (
    <p className="text-red-500 text-[10px] left-2">
      Resource Description is required
    </p>
  )}
</div>



                    {/* Category Name */}
                    <div className="md:col-span-2 col-span-1">
                      <label className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2">
                        Category Name *
                      </label>
                      <input
                        name="categoryName"
                        placeholder="Enter Category Name"
                        type="text"
                        className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
                        value={churchInputs?.categoryName || rowData?.categoryName || ""}
                        onChange={handleChange}
                      />
                      {videoErrors?.categoryName && (
                        <p className="text-red-500 relative bottom-[-6px] text-[10px] left-2">
                          Category Name is required
                        </p>
                      )}
                    </div>

                    {/* Resource URL */}
                    <UploadControlsV2
                      tooltipTitle="Upload Resouce Url"
                      className="my-2 col-span-2 mr-1"
                      title="Resource Url *"
                      showPreview={true}
                      subtitle="Upload Image"
                      handleChangeUrl={(event) =>
                        handleInputChange(event, setTumbNailUrlsInputs)
                      }
                      webUploadProgressId="logoUrlAddChurchLogo"
                      handleWebFileUpload={(e) =>
                        handleFileInputChange(
                          setChurchInputs,
                          "webUploadUrl",
                          e.target.files[0],
                          null,
                          "logoUrlAddChurchLogo",
                          false,
                          "church_logo_urls"
                        )
                      }
                      webUploadUrl={churchInputs?.resourceUrl || rowData?.resourceUrl || ""}
                      handleWebPreview={() => {
                        setIsImage(true);
                        setShowModal(true);
                        setCurrentUrl(churchInputs?.resourceUrl || rowData?.resourceUrl || "");
                      }}
                      isFieldRequired={videoErrors?.church_logo_urls}
                      requiredMessage="Church Logo is required"
                      showMobileUpload={false}
                      showTabletUpload={false}
                      showWebUpload={true}
                    />
            <div className="my-2 col-span-2 mr-1">
                    {/* <GalleryPickerField
  label=" Cover Image"
  name="galleryImage"
  church={church}
  rowData={rowData}
  value={{
    web: { url: tumbNailUrlsInputs?.webUploadUrl },
    tablet: { url: tumbNailUrlsInputs?.tabletUploadUrl },
    mobile: { url: tumbNailUrlsInputs?.mobileUploadUrl },
  }}
  handleChange={handleGallerySelect}
/> */}
{/* <GalleryVideoField
        label="Select Video"
        name="thumbnail"
        church={church}
        handleChange={handleThumbSelect}
      /> */}
                {/* <div className="flex items-center gap-4 mt-4">
        <input
          type="checkbox"
          id="liveCheckbox"
          className="w-4 h-4 cursor-pointer accent-yellowish appearance-none border border-gray-300 rounded-full checked:bg-yellow-500 checked:border-yellow-500"
          checked={isLive}
          onChange={(e) => setIslive(e.target.checked)}
        />
        <label htmlFor="liveCheckbox" className="cursor-pointer select-none">
          Live
        </label>

        <input
          type="checkbox"
          id="defaultCheckbox"
          className="w-4 h-4 cursor-pointer accent-yellowish appearance-none border border-gray-300 rounded-full checked:bg-yellow-500 checked:border-yellow-500"
          checked={isDefault}
          onChange={(e) => setIsDefault(e.target.checked)}
        />
        <label htmlFor="defaultCheckbox" className="cursor-pointer select-none">
          Default
        </label>
      </div> */}
</div>

                  </div>
                </div>
              </div>

            )}
            <Tooltip id="add_church" className="border border-greyish border-opacity-20" />
          </div>
        </div>
      </div>
      <CollapsibleRightPanel title="Stats / Layouts">
        <CustomTabsV2
          tabHeight={"h-[64px]"}
          tabsTitleArray={["Stats", "Layouts"]}
          tabsContentObject={{
            Stats: (
              <div className="mt-8 flex items-center justify-center w-full text-white">
                {data?._id ? (
                  <div className="w-full px-8">
                    <p>
                      Views : <strong>{videoInputs?.totalViews}</strong>
                    </p>
                    <p>
                      Likes: <strong>{videoInputs?.totalLikes}</strong>
                    </p>
                  </div>
                ) : (
                  <>No stats available for video</>
                )}
              </div>
            ),
            Layouts: !data?._id ? (
              <div className="mt-8 flex items-center justify-center w-full text-white">
                Save this Church to assign the layout
              </div>
            ) : (
              <>
                <div className="mt-4 p-1">
                  <label htmlFor="relatedVideos" className="text-[12px] text-greyish font-medium">
                    Layouts
                  </label>
                  <div className="bg-blackish py-4 px-3 mt-3 rounded-lg">
                    <LayoutDropdown
                      setMyState={setLayoutValues}
                      setLayoutInfo={setLayoutInfo}
                      setAddedLayout={setAddedLayout}
                      addedLayout={addedLayout}
                      newTarget={editTargetLayout}
                      isLayoutEdit={isLayoutEdit}
                      outerTargetLayout={layoutValues?.layout_name}
                    />

                    {layoutInfo && (
                      <>
                        <div className="flex gap-3">
                          <div className="w-full">
                            <label
                              htmlFor="order"
                              className="text-[12px] text-greyish font-medium leading-4 "
                            >
                              Display Order
                            </label>
                            <input
                              type="text"
                              className={`bg-greyishV2 p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10`}
                              name="order"
                              placeholder="Enter order"
                            //   value={layoutValues?.order}
                              onChange={handleVideoLayoutChange}
                            />
                          </div>
                        </div>
                        <div className="flex justify-end mt-4">
                          <div className="flex gap-3">
                            {!isLayoutEdit && (
                              <button
                                className="text-greyish bg-blackishV2 font-medium text-[12px] rounded-xl py-2 px-6"
                                onClick={() => {
                                  setLayoutValues(initialLayoutValues);
                                  setLayoutInfo(false);
                                }}
                              >
                                Cancel
                              </button>
                            )}
                            {isLayoutEdit ? (
                              <button
                                className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                                onClick={handleLayoutUpdate}
                              >
                                Confirm
                              </button>
                            ) : (
                              <button
                                className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                                onClick={handleAddLayoutToArray}
                              >
                                Add
                              </button>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                {layoutArray?.length > 0 &&
                  activeTab === "en" &&
                  layoutArray?.map((item, index) => (
                    <div className="w-full px-4 mt-4">
                      <div className="w-full p-2 px-4 bg-black bg-opacity-10 rounded-lg border border-opacity-25 border-white">
                        <div className="flex flex-col items-center justify-center w-full text-white">
                          <div className="flex justify-between w-full">
                            <p className="text-sm font-white font-medium text-white">
                              {item?.layout_name}
                            </p>
                            <div className="flex gap-2 justify-end items-center cursor-pointer">
                              <img
                                className="h-4"
                                src={edit}
                                alt=""
                                onClick={() => {
                                  setIsLayoutEdit(true);
                                  setEditLayoutIndex(index);
                                  setLayoutValues(item);
                                  setEditTargetLayout(item?.layout_name);
                                }}
                              />
                              <img
                                className="h-4"
                                src={close}
                                alt=""
                                onClick={() => {
                                  handleDeleteLayoutFromArray(item?._id);
                                }}
                              />
                            </div>
                          </div>
                          <div className="flex justify-between w-full mt-5 bg-blackishV2 p-1 px-2">
                            <p className="text-[10px] font-white text-white">Order</p>
                          </div>
                          <div className="flex w-full mt-2 p-1 px-2">
                            <p className="flex w-full text-xs font-white font-bold text-white">
                              {item?.order}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </>
            ),
          }}
        />
      </CollapsibleRightPanel>
     <ReactModal isOpen={showModal} onRequestClose={() => setShowModal(false)}>
            <div className="flex justify-center h-full w-full relative">
              <div
                className="absolute top-0 right-0 cursor-pointer"
                onClick={() => setShowModal(false)}
              >
                <ImCross />
              </div>
              {isImage ? (
                <img className="h-full" src={currentUrl} />
              ) : (
                <video className="h-full" controls autoPlay>
                  <source src={currentUrl} />
                </video>
              )}
            </div>
          </ReactModal>
    </div>
  );
};

export default AddVideosFields;
